import Card from "components/card";
import { DataGrid } from "@mui/x-data-grid";
import CategoriesDrawer from "./CategoriesDrawer";
import React, { useState, useEffect } from "react";
import { getAllCategories } from "../functions";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import CategoriesDelete from "./CategoriesDelete";
import { setDefaultData } from "store/modules/Categories";
import { columns } from "../columns";
import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";

const CategoriesTable = () => {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [mode, setMode] = useState("POST");
  const [rutaData, setCategoriesData] = useState(null);
  const [dataColumns, setDataColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      let response = await getAllCategories();
      setCategoriesData(response);
      let col = columns(setOpen, setMode, setOpenDelete, dispatch);
      setDataColumns(col);
    };
    fetchData();
  }, [open, openDelete, dispatch]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <CategoriesDelete openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <CategoriesDrawer open={open} handleClose={handleClose} mode={mode} />
      <Card extra={"w-full h-full p-5"}>
        <div className="relative flex items-center justify-end">
          <button
            onClick={() => {
              setOpen(true);
              dispatch(setDefaultData(null));
              setMode("POST");
            }}
            className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20"
          >
            Nueva Categoria
          </button>
        </div>
        {rutaData ? (
          <DataGridMarifer rows={rutaData || []} columns={dataColumns || []} />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};

export default CategoriesTable;
